import { defineStore } from 'pinia'
import {
  Subscription,
  Subscriptions,
  WarningType,
} from '@/types/subscriptions.interfaces'

interface State {
  all: Record<string, Subscription>
  has_warnings: boolean
  warning_type?: WarningType
  warning_count: number
  warning_total_fees: number
  hide_banner: boolean
  loading: boolean
}

const useSubscriptionsStore = defineStore({
  id: 'subscriptions',

  state: (): State => ({
    all: {},
    has_warnings: false,
    warning_type: undefined,
    warning_count: 0,
    warning_total_fees: 0,
    hide_banner: false,
    loading: false,
  }),

  actions: {
    setSubscription(subscribtion: Subscription) {
      this.all[subscribtion.productName] = subscribtion
    },

    setInBatch({
      subscriptions,
      has_warnings,
      warning_type,
      warning_count,
      warning_total_fees,
      hide_banner,
  }: Subscriptions) {
      subscriptions.forEach((subscription) => {
        this.setSubscription(subscription)
      })
      this.has_warnings = has_warnings
      this.warning_type = warning_type
      this.warning_count = warning_count
      this.warning_total_fees = warning_total_fees
      this.hide_banner = hide_banner
    },
  },

  getters: {
    list(state): Subscription[] {
      return Object.values(state.all)
    }
  }
})

export default useSubscriptionsStore
